export type AnyFunction = (...args: any[]) => any

export type AnyAsyncFunction = (...args: any[]) => Promise<any>

/** The underlying result type of the async function `F`. `F: (args => Promise<T>) -> T` */
export type Promised<F extends AnyAsyncFunction> = Awaited<ReturnType<F>>

export type JSONValue = string | number | boolean | {[x: string]: JSONValue} | JSONValue[]
